const destination = [
    {
        id : 'C001',
        place_name : 'Medan',
        code : 'MDN',
        
    },
    {
        id : 'C002',
        place_name : 'Bukit Lawang',
        code : 'BKL',
        
    },
    {
        id : 'P001',
        place_name : 'Own Program',
        code : 'OWN',
        
    },
    
]

export default destination